import { Stack } from '@chakra-ui/react';
import AppBox from 'components/AppBox/AppBox';
import AppInput from 'components/AppInput/AppInput';
import AppText from 'components/typography/AppText';
import { memo } from 'react';

const ShortTextField = ({
  isEditable,
  state,
  setState,
  index,
  error,
  item,
  type,
  fieldName,
}) => {
  const placeholder_text = item?.question?.placeholder_text;
  const help_text = item?.question?.help_text;

  return (
    <Stack>
      <AppBox>
        <AppInput
          variant={'filled'}
          isRequired={true}
          formValues={state}
          setFormValues={setState}
          fieldPlaceholder={placeholder_text}
          inputGroupPadding={'0px'}
          fieldName={fieldName}
          disabled={!isEditable}
          item={item}
          type={type}
        />
        <AppText
          text={help_text}
          customStyles={{
            fontSize: '12px',
            color: '#757575',
            lineHeight: '15.6px',
            padding: '10px 0 4px',
          }}
        />
      </AppBox>
      <AppText
        text={
          error?.data?.answers_data[index]?.answer_short_text_input ||
          error?.data?.answers_data[index]?.non_field_errors
        }
        variant="errorMessage"
      />
    </Stack>
  );
};

export default memo(ShortTextField);
